import { User } from '@shared/models/user.model';

export const OPEN_AI_USER_ID = 'open-ai'; // DO NOT CHANGE WITHOUT MIGRATION COMMENTS

export const OPEN_AI_USER: User = Object.freeze({
  id: OPEN_AI_USER_ID,
  name: 'Nodon AI',
  nickname: 'Nodon AI',
  picture: '/images/nodon-ai-avatar.png',
  organizations: [],
});
